import { CoreUserAgent } from "../UserAgent";
import { CoreBaseLoader } from "./_Base";
const _CoreLoaderTexture = class extends CoreBaseLoader {
  constructor(_url, _node) {
    super(_url, _node);
    this._node = _node;
  }
  static onTextureLoaded(callback) {
    this._onTextureLoadedCallback = callback;
  }
  static replaceExtension(url, new_extension) {
    const elements = url.split("?");
    const url_without_params = elements[0];
    const url_elements = url_without_params.split(".");
    url_elements.pop();
    url_elements.push(new_extension);
    return [url_elements.join("."), elements[1]].join("?");
  }
  static setMaxConcurrentLoadsCount(method) {
    this._maxConcurrentLoadsCountMethod = method;
  }
  static _init_max_concurrent_loads_count() {
    if (this._maxConcurrentLoadsCountMethod) {
      return this._maxConcurrentLoadsCountMethod();
    }
    return CoreUserAgent.isChrome() ? 10 : 4;
  }
  static _init_concurrent_loads_delay() {
    return CoreUserAgent.isChrome() ? 0 : 10;
  }
  static incrementInProgressLoadsCount() {
    this.in_progress_loads_count++;
  }
  static decrementInProgressLoadsCount() {
    this.in_progress_loads_count--;
    const queued_resolve = this._queue.pop();
    if (queued_resolve) {
      const delay = this.CONCURRENT_LOADS_DELAY;
      setTimeout(() => {
        queued_resolve();
      }, delay);
    }
  }
  static async waitForMaxConcurrentLoadsQueueFreed() {
    if (this.in_progress_loads_count <= this.MAX_CONCURRENT_LOADS_COUNT) {
      return;
    } else {
      return new Promise((resolve) => {
        this._queue.push(resolve);
      });
    }
  }
};
export let CoreLoaderTexture = _CoreLoaderTexture;
CoreLoaderTexture.MAX_CONCURRENT_LOADS_COUNT = _CoreLoaderTexture._init_max_concurrent_loads_count();
CoreLoaderTexture.CONCURRENT_LOADS_DELAY = _CoreLoaderTexture._init_concurrent_loads_delay();
CoreLoaderTexture.in_progress_loads_count = 0;
CoreLoaderTexture._queue = [];
